import React from "react";
import BenefitsSection from "../Home/BenefitsSection.jsx";

const BenefitsPage = () => <BenefitsSection />;

export default BenefitsPage;
